module.exports = __webpack_public_path__ + "img/bubbles-github.860a4c62.svg";